'use strict';

let processInclude = require('./util');
require('./components/spinner');

$(document).ready(function () {
  processInclude(require('./product/detail'));
  
  //### START CUSTOM ADYEN ALPENITE ###
  processInclude(require('int_custom_adyen/adyen/express/product/expressPayments'));
  // ### END CUSTOM ADYEN ALPENITE ###
});
